import React, { Component } from 'react';
import { Menu } from 'semantic-ui-react';
import base, { firebase } from '../rebase';
import DownloadCurrentStatus from './DownloadCurrentStatus';
import SelectTouroperator from './SelectTouroperator';

export default class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {tour_operators : null};

    this.logoutUser = this.logoutUser.bind(this);
  }

  componentDidMount() {
    if (!this.props.authUser.isAdmin) return;

    base.bindToState('tour_operators', {
      context: this,
      state: 'tour_operators'
    })
  }

  logoutUser(e) {
    firebase.auth().signOut().then(function() {
      // Signed out
    }).catch(function(error) {
      // Error signing out
      console.log(error); 
    });
  }

  render() {
    return (
      <Menu fixed="top" color="green" inverted>
        <Menu.Item header>Transavia portal</Menu.Item>
        <Menu.Menu position='right'>
          <DownloadCurrentStatus authUser={this.props.authUser} /> 
          <SelectTouroperator 
                authUser={this.props.authUser}
                tour_operators={this.state.tour_operators}
                onChange={this.props.changeTop}
            />
          <Menu.Item header>{this.props.authUser.display_name}</Menu.Item> 
          <Menu.Item name='logout' onClick={this.logoutUser} />
        </Menu.Menu>
      </Menu>
    ); 
  }
}


// WEBPACK FOOTER //
// ./src/common/Navbar.js